module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pkppqj/tc-custom/9781625673886.jpg?1726444326051",
      "alt": "This image is the cover for the book Witch, Doppelganger"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Witch, Doppelganger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Revolution has come to Starfall.")]), _c('br'), _c('br'), _vm._v("To some, Mirei is a savior. Born from the union of opposing forces, her existence offers a way to heal the division between warrior and witch, and brings powerful new magic into the world."), _c('br'), _c('br'), _vm._v("To others, Mirei is an abomination. She overturns the ancient traditions of the witches, threatening their stability and corrupting their magic with an influence that should be destroyed."), _c('br'), _c('br'), _vm._v("But even Mirei's power is not enough to prevent a civil war. And while she struggles to reconcile Starfall's opposing factions, a more insidious threat is building within her -- because her newfound magic does not come without a price.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marie Brennan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marie Brennan is a former anthropologist and folklorist who shamelessly pillages her academic fields for material. She most recently misapplied her professors’ hard work to the Hugo Award-nominated Victorian adventure series The Memoirs of Lady Trent; the first book of that series, "), _c('i', [_vm._v("A Natural History of Dragons")]), _vm._v(", was a finalist for the World Fantasy Award and won the Prix Imaginales for Best Translated Novel. She is also the author of the Doppelganger duology of "), _c('i', [_vm._v("Warrior")]), _vm._v(" and "), _c('i', [_vm._v("Witch")]), _vm._v(", the urban fantasies "), _c('i', [_vm._v("Lies and Prophecy")]), _vm._v(" and "), _c('i', [_vm._v("Chains and Memory")]), _vm._v(", the Onyx Court historical fantasy series, the Varekai novellas, the collaborative novel "), _c('i', [_vm._v("Born to the Blade")]), _vm._v(", and more than fifty short stories. For more information, visit "), _c('a', {
    attrs: {
      "href": "http://www.swantower.com"
    }
  }, [_vm._v("www.swantower.com.")])])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    JABberwocky Literary Agency, Inc\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0